import React, { useContext } from "react";
import { DrawModeChangeEvent } from "@mapbox/mapbox-gl-draw";
import { AddRoad } from "@mui/icons-material";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";
import { useLayerEditable } from "./useLayerEditable";

const SnapAddButton: React.FC<IButtonProps> = ({ icon, title = "Add path" }) => {
  const { map, drawControl } = useContext(MapContext);
  const isLayerEditable = useLayerEditable();

  const handleOnClick = () => {
    if (!drawControl.current) return;
    drawControl.current.changeMode("snap_add_feature");
    map?.fire("draw.modechange", { type: "draw.modechange", mode: "snap_add_feature" } as unknown as DrawModeChangeEvent);
  };

  return (
    <ToolbarToggleButton
      title={title}
      value="snap_add_feature"
      onClick={handleOnClick}
      data-testid="toolbar-snap-add-button"
      disabled={!isLayerEditable}
    >
      {icon || <AddRoad />}
    </ToolbarToggleButton>
  );
};

export default SnapAddButton;
